module.exports = __webpack_public_path__ + "img/dooball.4a924943.png";